<template>
	<div class="cms-rich-text" v-html="sanitizedContent"></div>
</template>

<script>
/**
 * RichText.vue
 * ────────────
 * A pure presentational block that renders sanitised HTML content.
 *
 * SECURITY NOTE: The `content` prop is expected to be sanitised at the
 * data layer before it reaches this component (e.g. via DOMPurify on
 * ingest or on the server). As a defence-in-depth measure, the shared
 * sanitizeHtml utility removes <script> and event-handler attributes
 * before rendering.
 *
 * Alignment and typography are wrapper style traits; this block inherits
 * them from the wrapper element.
 *
 * This component knows nothing about the CMS, Vuex, or drag-and-drop.
 * It only accepts standard Vue props.
 */
import { sanitizeHtml } from '@/websites/cms/blocks/shared/blockUtils.js';

export default {
	name: 'RichText',

	props: {
		content: {
			type: String,
			default: ''
		}
	},

	computed: {
		sanitizedContent: function () {
			return sanitizeHtml(this.content);
		}
	}
};
</script>

<style scoped>
.cms-rich-text {
	width: 100%;
	max-width: 100%;
	text-align: inherit;
	color: inherit;
	line-height: 1.6;
	word-wrap: break-word;
}

.cms-rich-text >>> h2 {
	margin: 0 0 0.5rem 0;
	font-size: 1.5em;
	text-transform: none;
}

.cms-rich-text >>> h3 {
	margin: 0 0 0.5rem 0;
	font-size: 1.25em;
	text-transform: none;
}

.cms-rich-text >>> p {
	margin: 0 0 1rem 0;
}

.cms-rich-text >>> p:last-child {
	margin-bottom: 0;
}

.cms-rich-text >>> ul,
.cms-rich-text >>> ol {
	margin: 0 0 1rem 0;
	padding-left: 1.5rem;
}

.cms-rich-text >>> img {
	max-width: 100%;
	height: auto;
	border-radius: 4px;
	margin: 0.5rem 0;
}

.cms-rich-text >>> a {
	color: var(--site-link-color, #0080FF);
	text-decoration: underline;
}
</style>
